const HP_EMAIL_DOMAIN = 'hp.com'

export const isHpEmail = (email?: string | null) => {
  const atIndex = email?.lastIndexOf('@') ?? -1

  if (!email || atIndex === -1) {
    return false
  }

  const domain = email.slice(atIndex + 1).trim()

  return domain.toLowerCase() === HP_EMAIL_DOMAIN
}
